// The size guide opens in a dialog on the product page instead of taking the bride off the
// dress she is looking at. The numbers keep one home: the chart section of the measuring
// guide (templates/page.how-to-measure.json -> sections/madmire-measure-guide.liquid), which
// this lifts out of a fetch of that page, so there is nothing to keep in sync. The guide page
// is ~340 KB, so the fetch starts on the first hover or tap of the link, not on the click.
// The chart's CSS is in the block (Horizon bundles a section's stylesheet only on the pages
// that render it), and the link is localized by Shopify, so /uk/ fetches the Ukrainian page.
//
// Without JS, or if the fetch fails, the link stays an ordinary link to the guide.

const load = (link, body) => {
  body.loading ??= (async () => {
    const response = await fetch(link.href, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(response.status);
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const chart = page.querySelector('.mm-guide__chart');
    if (!chart) throw new Error('no chart section on the guide page');
    body.replaceChildren(chart);
    body.dataset.state = 'ready';
  })().catch((error) => {
    body.loading = null; // let the click try again
    throw error;
  });
  return body.loading;
};

const parts = (event) => {
  const link = event.target.closest?.('.madmire-size-chart__link');
  const dialog = link?.closest('.madmire-size-chart')?.querySelector('dialog.madmire-size-chart__dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return null;
  return { link, dialog, body: dialog.querySelector('.madmire-size-chart__dialog-body') };
};

// Hover on a mouse, the touch right before the tap on a phone: by the click the chart is here.
document.addEventListener(
  'pointerover',
  (event) => {
    const found = parts(event);
    if (found) load(found.link, found.body).catch(() => {});
  },
  { passive: true }
);

document.addEventListener('click', (event) => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const dialog = event.target.closest('dialog.madmire-size-chart__dialog');
  if (dialog) {
    // Click on the backdrop: the event lands on the dialog itself, outside its box.
    const box = dialog.getBoundingClientRect();
    const outside =
      event.clientY < box.top || event.clientY > box.bottom || event.clientX < box.left || event.clientX > box.right;
    if (outside) dialog.close();
    return;
  }

  const found = parts(event);
  if (!found) return;

  event.preventDefault();
  found.dialog.showModal();
  if (found.body.dataset.state !== 'ready') found.body.dataset.state = 'loading';
  load(found.link, found.body).catch(() => {
    // ponytail: the guide page is the fallback, so send her there instead of retrying
    found.body.dataset.state = '';
    found.dialog.close();
    location.href = found.link.href;
  });
});
